import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';

export default function DeleteDialogueBoxV2(param: any) {
    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }
    return (
        <div className="ws-6">

            <Modal open={param.param} onClose={() => returnValue(2)} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >
                <div className="box">

                    <div className="box-header-main well">
                        <h2><i className="fa fa-question-circle"></i> {param?.title ?? "Confirm"}  ?</h2>
                    </div>

                    <div className="box-content">
                        {param?.description && param?.description?.length > 0 && <div dangerouslySetInnerHTML={{ __html: param?.description }} />}

                        {param.message && param?.message?.length > 0 && <span>Are you sure you want to {param.message} ?</span>}

                        {param?.descriptionBelow && param?.descriptionBelow?.length > 0 && <div dangerouslySetInnerHTML={{ __html: param?.descriptionBelow }} />}
                    </div>

                    <div className="box-footer">
                        <button className="icon-btn edit width120 height35" onClick={() => returnValue(1)} > Save</button>
                        <button className="icon-btn edit width120 height35" onClick={() => returnValue(2)} > Save and Reset</button>
                        <button className="icon-btn delete width120 height35" onClick={() => returnValue(0)} > Close</button>
                    </div>

                </div>
            </Modal>

        </div>
    )
}